import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleTryAgain = this.handleTryAgain.bind(this);
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Centralized render-error logging (swap with Sentry later if desired).
    console.error("Render error caught by ErrorBoundary:", error, errorInfo);
  }

  handleTryAgain() {
    this.setState({ hasError: false });
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    // Spezialfall (R3.1): bewusst Inline-Styles statt Tailwind-Klassen, damit
    // der Crash-Fallback auch ohne App-CSS rendert. Hexwerte = v2-Token-Werte
    // (ink #0F172A, ink-soft #475569, line #E7E5E4, brand #FF7A3D).
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
        <div style={{ maxWidth: 520, width: "100%", border: "1px solid #E7E5E4", borderRadius: 12, background: "#FFFFFF", padding: 24 }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: "#0F172A", marginBottom: 8 }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 14, color: "#475569", marginBottom: 16, lineHeight: 1.5 }}>
            The page ran into an unexpected problem. You can try again, or reload the page.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              type="button"
              onClick={this.handleTryAgain}
              style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid #E7E5E4", background: "#FFFFFF", color: "#0F172A", fontWeight: 600, cursor: "pointer" }}
            >
              Try again
            </button>
            <button
              type="button"
              onClick={this.handleReload}
              style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid #FF7A3D", background: "#FF7A3D", color: "#FFFFFF", fontWeight: 700, cursor: "pointer" }}
            >
              Reload page
            </button>
          </div>
        </div>
      </div>
    );
  }
}

